import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import { useEffect, useRef, useState } from 'react';
import { useOuterClick } from 'Services/helpers';
import TagGroup from '../../TagGroup/TagGroup';
import styles from './SelectField.module.sass';
import SelectFieldItem from './SelectFieldItem';

const SelectField = ({isEdit, value, onChange, fieldProperties}: any) => {
    const [data, setData] = useState<any>({
        selected: value || (fieldProperties?.list.find((item: any) => item.isDefault))?.value || null,
        list: fieldProperties?.list || [],
        labels: {}
    });
    const [state, setState] = useState({
        isFocused: false,
        isOpen: false
    });
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => setState({...state, isFocused: false}));

    useEffect(() => {
        if (!state.isFocused) return;
        inputRef?.current?.focus();
    }, [state.isFocused]);

    useEffect(() => {
        if (fieldProperties?.list) {
            const labels: any = {};
            fieldProperties?.list?.forEach((i: any) => {
                labels[i?.value] = i?.label
                
                if (i?.children) {
                    i.children.forEach((j: any) => {
                        labels[j?.value] = '../' + j?.label;
                    });
                }
            })
            setData({
                ...data,
                labels,
                list: fieldProperties.list
            });
        }
    }, [fieldProperties.list]);

    const handleClick = (value: any) => {
        onChange(value);
        setData({...data, selected: value});
        setTimeout(() => {
            setState({...state, isFocused: false});
        }, 100);
    }
    const handleFocusClick = () => {
        if (!fieldProperties.isDisabled) {
            setState({...state, isFocused: true});
        }
    };

    if (!isEdit) {
        if (!data.selected) {

            return <NoValue />;
        }

        return <TagGroup alignRight={!fieldProperties.alignLeft} isCollapsed={fieldProperties.isInline}>
            <Tag transparent tooltip={value?.includes('+') ? data.labels?.[value.split('+')[0]] : undefined}>
                { data.labels?.[value] }
            </Tag>
        </TagGroup>;
    }

    return !isEdit
    ? <>{fieldProperties?.list.find((item: any) => item.value == value)?.label || <NoValue />}</>
    : <div className={`
        ${styles['selectfield']}
        ${state.isFocused ? styles['selectfield--active'] : ''}
        ${fieldProperties.isDisabled ? styles['selectfield--disabled'] : ''}
    `}
        onClick={handleFocusClick}
        ref={innerRef}
    >
        {
            !data.selected &&
            <div className={`${styles['selectfield__content']}`}>
                <input placeholder={'Selecteer een waarde...'} style={{pointerEvents: 'none'}}/>
            </div>
        }
        {
            data.selected && <>
                <TagGroup fullWidth>
                    <Tag transparent>{ data?.labels?.[value] }</Tag>
                </TagGroup>

                {
                    !fieldProperties.isDisabled
                    && <div className={styles['selectfield__icon']} onClick={() => handleClick(null)}>
                        <Icon type={ICONS.CLOSE} size={'xsmall'} isCircled />
                    </div>
                }
            </>
        }
        <div className={styles['selectfield__icon']}>
            <Icon type={ICONS.CHEVRON_DOWN} size={'small'}/>
        </div>
        {
            state.isFocused &&
            <div className={styles['selectfield__dropdown']}>
                {
                    data.list.map((item: any) => 
                        <SelectFieldItem
                            key={item?.value}
                            item={item}
                            labels={data.labels}
                            iteration={-1}
                            activeValues={data.selected}
                            onClick={(v) => handleClick(v)}
                        />
                    )
                }
                { data.list.length == 0 && <div className={`${styles['selectfield__dropdown__item']}`} style={{fontStyle: 'italic'}}>Geen resultaten gevonden...</div>}
            </div>
        }
    </div>;
}

export default SelectField;